import { openBlock as c, createElementBlock as e, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ t("path", { d: "M21.66 7.045c-.08-.23-.21-.46-.38-.64-.19-.21-.4-.32-.75-.52l-7.39-4.11c-.33-.18-.52-.29-.79-.35-.23-.05-.47-.05-.71 0-.26.05-.47.17-.79.35l-7.4 4.12c-.34.19-.55.31-.74.51-.17.19-.3.4-.38.64-.09.27-.09.51-.09.9v8.12c0 .4 0 .63.09.9.08.24.21.45.37.64.19.21.4.32.75.52l7.4 4.11c.32.18.52.29.79.35.12.02.23.04.35.04.12 0 .24-.01.35-.04.26-.05.46-.16.79-.35l7.4-4.11c.35-.19.55-.31.75-.52.17-.18.3-.4.37-.64.09-.27.09-.51.09-.9v-8.12c0-.4 0-.64-.09-.9h.01Zm-10.07-3.96c.15-.08.32-.18.36-.19h.1c.04.01.21.1.36.19l7.04 3.91-2.96 1.64-7.45-4.13 2.54-1.41.01-.01Zm-.34 17.64-7.07-3.93c-.16-.09-.33-.18-.37-.22a.405.405 0 0 1-.05-.09c-.01-.05-.01-.24-.01-.43v-7.78l7.5 4.17v8.28Zm.75-9.58-7.46-4.14 2.96-1.64 7.46 4.14-2.96 1.64Zm8.25 4.91c0 .19 0 .38-.01.43-.01.03-.03.06-.05.09-.04.03-.21.13-.37.22l-7.06 3.92v-8.28l7.5-4.17v7.78l-.01.01Z" }, null, -1), n = [
  o
];
function r(s, a) {
  return c(), e("svg", l, [...n]);
}
const v = { render: r };
export {
  v as default,
  r as render
};
